import { Flex, type FlexProps, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreCustomer } from '@flecto/types'
import { Badge, TextCopy } from '@flecto/ui'

export type CellCustomerProps = FlexProps & {
  customer?: CoreCustomer
}

export function CellCustomer({ customer, ...props }: CellCustomerProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking' })

  if (!customer) {
    return (
      <Flex {...props}>
        <Badge color='gray'>{t('table.no_booking_customer_selected')}</Badge>
      </Flex>
    )
  }

  return (
    <Flex {...props} direction='column' gap='xs' style={{ flexShrink: 1 }}>
      <Text fw={500} lh={1.2} truncate>
        {customer.full_name}
      </Text>
      <Flex align='center' gap='sm'>
        {customer.email && (
          <TextCopy size='sm' c='dimmed'>
            {customer.email}
          </TextCopy>
        )}
        {customer.phone_number && (
          <TextCopy size='sm' c='dimmed'>
            {customer.phone_number}
          </TextCopy>
        )}
      </Flex>
    </Flex>
  )
}
